import { render, staticRenderFns } from "./GoCompositionEchart.vue?vue&type=template&id=4bd8da46&scoped=true&"
import script from "./GoCompositionEchart.vue?vue&type=script&lang=js&"
export * from "./GoCompositionEchart.vue?vue&type=script&lang=js&"
import style0 from "./GoCompositionEchart.vue?vue&type=style&index=0&id=4bd8da46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd8da46",
  null
  
)

export default component.exports